module.exports = __webpack_public_path__ + "static/media/AL.b0c98c29.svg";